export const iconFontAwesomeTextformattingListOl = (
	<i className="fa-solid fa-list-ol"></i>
);
